module.exports = __webpack_public_path__ + "img/preloader.13795025.svg";